var React = require('react');

function GraphIncrease (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M0 2v16h20v-1H1V2H0zm14.465 3-1.06 1.06h2.827L10.4 11.894l-3.677-1.84a.5.5 0 0 0-.577.093l-4 4c-.49.472.236 1.198.708.708L6.6 11.107l3.677 1.84a.5.5 0 0 0 .577-.093l6.085-6.086v2.828L18 8.536V5h-3.535z","fill":"#f0f9ff","fillOpacity":"1","stroke":"none","strokeWidth":"0","className":"fill-222222"}));
}

GraphIncrease.defaultProps = {"viewBox":"0 0 20 20"};

module.exports = GraphIncrease;

GraphIncrease.default = GraphIncrease;
